import { RouteObject } from 'react-router-dom';
import { NuqsAdapter } from 'nuqs/adapters/react-router/v6';
import { DashboardPage } from './pages/dashboard';
import { AgencyPage } from './pages/agency';
import { CreatePage } from './pages/create';
import Authorizer from './common/authorizer';
import { ContactListsPage } from './pages/contact-lists';

const campaignsRouteDefinitions: RouteObject[] = [
  {
    element: (
      <NuqsAdapter>
        <div className='font-sans font-[450] min-h-full'>
          <Authorizer />
        </div>
      </NuqsAdapter>
    ),
    children: [
      {
        path: '/portal/campaigns/',
        element: <DashboardPage />
      },
      {
        path: '/portal/campaigns/agency/:agencyId',
        element: <AgencyPage />
      },
      {
        path: '/portal/campaigns/contact-lists',
        element: <ContactListsPage />
      },
      {
        path: '/portal/campaigns/create',
        element: <CreatePage />
      }
    ]
  }
];

export { campaignsRouteDefinitions };
